import styled from "styled-components";
import { Button, Typography } from "@bracket/ui";

const BottomBarWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 2rem;

  &:has(.stake-first) {
    justify-content: center;
  }

  @media (min-width: 1400px) {
    flex-direction: row !important;
  }
`;

const ErrorMessage = styled(Typography)`
  flex-basis: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

type ChartBottomBarProps = {
  reward: number;
  isDisabled: boolean;
  onWillStayClick: () => void;
  onWillBreakOutClick: () => void;
  hasStaked: boolean | null;
  barsExceeded: boolean;
};

export const ChartBottomBar = ({
  reward,
  isDisabled,
  onWillStayClick,
  onWillBreakOutClick,
  hasStaked,
  barsExceeded,
}: ChartBottomBarProps) => {
  return (
    <BottomBarWrapper>
      {!hasStaked && !barsExceeded && (
        <Button
          className="stake-first"
          label="Stake first to play"
          onClick={() => window.history.pushState({}, "", "/stake")}
          width="30%"
          maxWidth="30%"
        />
      )}
      {hasStaked && barsExceeded && (
        <ErrorMessage variant="h5" color="var(--error)">
          Daily bars limit exceeded
        </ErrorMessage>
      )}
      {hasStaked && !barsExceeded && (
        <>
          <Button
            label="Price will stay [IN]"
            onClick={onWillStayClick}
            disabled={isDisabled || barsExceeded}
            width="100%"
            maxWidth="100%"
          />
          <Button
            label="Price will break out"
            onClick={onWillBreakOutClick}
            variant="destructive"
            disabled={isDisabled || barsExceeded}
            width="100%"
            maxWidth="100%"
          />
        </>
      )}
    </BottomBarWrapper>
  );
};
